import React, { useEffect, useState } from "react";

const today = new Date();
const formattedDate = today.toLocaleDateString("en-GB", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

const PrivacyPolicy = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark-mode"));
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="privacy-policy-page"
      style={{
        maxWidth: 800,
        margin: "40px auto",
        padding: 24,
        background: isDarkMode ? "#181818" : "#fff",
        color: isDarkMode ? "#f5f5f5" : "#222",
        borderRadius: 12,
        boxShadow: isDarkMode
          ? "0 2px 16px rgba(0,0,0,0.36)"
          : "0 2px 16px rgba(0,0,0,0.06)",
        transition: "background 0.3s, color 0.3s"
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: 16 }}>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> {formattedDate}<br/>
      <strong>Last Updated:</strong> {formattedDate}</p>
      <p>Welcome to ZipAccounts.com. Your privacy is of utmost importance to us. This Privacy Policy describes how we collect, use, store, and protect your information when you visit our website or use our services.</p>
      <h2>1. Information We Collect</h2>
      <p>We may collect the following categories of personal and non-personal information:</p>
      <ul>
        <li><strong>Personal Information:</strong> Name, email address, phone number, billing address, payment details (such as credit/debit card or mobile wallet info), and any other information you provide during registration or transactions.</li>
        <li><strong>Non-Personal Information:</strong> Browser type, device information, IP address, pages visited, session duration, and other analytical data through cookies and similar technologies.</li>
      </ul>
      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Provide, operate, and improve our website and services.</li>
        <li>Process transactions and manage your account.</li>
        <li>Send you order updates, transaction confirmations, and customer support communications.</li>
        <li>Deliver personalized recommendations and offers based on your usage.</li>
        <li>Send newsletters, promotions, and marketing messages (only with your consent).</li>
        <li>Detect and prevent fraud, abuse, or security issues.</li>
      </ul>
      <h2>3. Data Protection and Security</h2>
      <p>We implement industry-leading security practices to protect your data, including:</p>
      <ul>
        <li>SSL encryption for data transmission.</li>
        <li>Secure payment gateways for transaction processing.</li>
        <li>Access controls and authentication protocols.</li>
        <li>Regular system monitoring and vulnerability assessments.</li>
      </ul>
      <p><strong>⚠️ Please note:</strong> While we take all reasonable precautions, no method of transmission over the internet is 100% secure.</p>
      <h2>4. Cookies and Tracking Technologies</h2>
      <p>We use cookies, beacons, and similar tools to:</p>
      <ul>
        <li>Enhance your browsing experience</li>
        <li>Store user preferences</li>
        <li>Analyze website traffic and performance</li>
        <li>Personalize ads and content</li>
      </ul>
      <p>You can manage or disable cookies through your browser settings. Note that disabling cookies may impact some functionalities of the website.</p>
      <h2>5. Sharing Your Information</h2>
      <p>We do not sell your personal data. However, we may share your information with:</p>
      <ul>
        <li>Trusted third-party service providers (e.g., payment processors, marketing platforms, analytics providers) who help us operate and improve our services.</li>
        <li>Legal authorities, if required to comply with applicable laws, regulations, or to protect our rights and users.</li>
      </ul>
      <p>All third parties are contractually obligated to keep your data secure and use it only for the specified purposes.</p>
      <h2>6. Your Rights and Choices</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you</li>
        <li>Request correction or deletion of your data</li>
        <li>Withdraw consent for marketing at any time via the unsubscribe link or by contacting us</li>
        <li>Request a copy of your data in a structured, machine-readable format (data portability)</li>
      </ul>
      <p>To exercise any of these rights, please contact us using the details below.</p>
      <h2>7. Data Retention</h2>
      <p>We retain your personal information only as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required or permitted by law.</p>
      <h2>8. Children's Privacy</h2>
      <p>Our services are not intended for children under 13 years of age. We do not knowingly collect or solicit personal information from minors. If we become aware that a child under 13 has provided us with personal data, we will promptly delete it.</p>
      <h2>9. International Data Transfers</h2>
      <p>If you are accessing our services from outside Pakistan, please note that your data may be transferred to, stored, and processed in jurisdictions that may not provide the same level of data protection as your country.</p>
      <h2>10. Changes to This Privacy Policy</h2>
      <p>We reserve the right to update this Privacy Policy as necessary. All changes will be reflected on this page with the "Last Updated" date. Your continued use of our services after any modification constitutes your acceptance of the revised policy.</p>
      <h2>11. Contact Us</h2>
      <p>If you have any questions, concerns, or requests related to this Privacy Policy or your personal information, please contact us:</p>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:info@nexagensolution.com">info@nexagensolution.com</a></li>
        <li><strong>Phone:</strong> <a href="tel:+923226069003">+92 315 666 6402, +92 303 7682000</a></li>
        <li><strong>Address:</strong> Ali Mall, 2nd floor, Susan road, Faisalabad, Pakistan</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy; 